import React from "react";
import { Navbar } from "../header";
import { Footer } from "../footer";
import "./PortfolioPage.css";

export const FoodBeveragePortfolio = () => {
  const galleryImages = [
    { id: 1, src: "/resources/images/f&b/f&b1.jpg", category: "Appetizer", title: "Gourmet Starter Platter" },
    { id: 2, src: "/resources/images/f&b/f&b2.jpg", category: "Main Course", title: "Signature Entrée Presentation" },
    { id: 3, src: "/resources/images/f&b/f&b3.jpg", category: "Dessert", title: "Decadent Dessert Selection" },
    { id: 4, src: "/resources/images/f&b/f&b4.jpg", category: "Beverage", title: "Refreshing Summer Drink" },
    { id: 5, src: "/resources/images/f&b/f&b5.jpg", category: "Appetizer", title: "Elegant Starter Display" },
    { id: 6, src: "/resources/images/f&b/f&b6.jpg", category: "Main Course", title: "Chef's Special Main Dish" },
    { id: 7, src: "/resources/images/f&b/f&b7.jpg", category: "Dessert", title: "Sweet Treats Assortment" },
    { id: 8, src: "/resources/images/f&b/f&b8.jpg", category: "Beverage", title: "Classic Cocktail Shot" },
    { id: 9, src: "/resources/images/f&b/f&b9.jpg", category: "Appetizer", title: "Seasonal Starter Plate" },
    { id: 10, src: "/resources/images/f&b/f&b10.jpg", category: "Main Course", title: "Gastronomic Main Course" },
    { id: 11, src: "/resources/images/f&b/f&b11.jpg", category: "Dessert", title: "Artisan Dessert Creation" },
    { id: 12, src: "/resources/images/f&b/f&b12.jpg", category: "Beverage", title: "Signature Mocktail" },
    { id: 13, src: "/resources/images/f&b/f&b13.jpg", category: "Appetizer", title: "Fusion Starter" },
    { id: 14, src: "/resources/images/f&b/f&b14.jpg", category: "Main Course", title: "Plated Perfection" },
    { id: 15, src: "/resources/images/f&b/f&b15.jpg", category: "Dessert", title: "Chocolate Indulgence" },
    { id: 16, src: "/resources/images/f&b/f&b16.jpg", category: "Beverage", title: "Exotic Drink Presentation" },
    { id: 17, src: "/resources/images/f&b/f&b17.jpg", category: "Appetizer", title: "Gourmet Bites" },
    { id: 18, src: "/resources/images/f&b/f&b18.jpg", category: "Main Course", title: "Elegant Main Dish" },
    { id: 19, src: "/resources/images/f&b/f&b19.jpg", category: "Dessert", title: "Fruit Medley" },
    { id: 20, src: "/resources/images/f&b/f&b20.jpg", category: "Beverage", title: "Chilled Beverage" },
    { id: 21, src: "/resources/images/f&b/f&b21.jpg", category: "Appetizer", title: "Starter Sampler" },
    { id: 22, src: "/resources/images/f&b/f&b22.jpg", category: "Main Course", title: "Classic Entrée" },
    { id: 23, src: "/resources/images/f&b/f&b23.jpg", category: "Dessert", title: "Pastry Selection" },
    { id: 24, src: "/resources/images/f&b/f&b24.jpg", category: "Beverage", title: "Iced Drink" },
    { id: 25, src: "/resources/images/f&b/f&b25.jpg", category: "Appetizer", title: "Tasting Plate" },
    { id: 26, src: "/resources/images/f&b/f&b26.jpg", category: "Main Course", title: "Hearty Main" },
    { id: 27, src: "/resources/images/f&b/f&b27.jpg", category: "Dessert", title: "Sweet Platter" },
    { id: 28, src: "/resources/images/f&b/f&b28.jpg", category: "Beverage", title: "Sparkling Drink" },
    { id: 29, src: "/resources/images/f&b/f&b29.jpg", category: "Appetizer", title: "Gourmet Appetizer" },
    { id: 30, src: "/resources/images/f&b/f&b30.jpg", category: "Main Course", title: "Signature Plate" },
    { id: 31, src: "/resources/images/f&b/f&b31.jpg", category: "Dessert", title: "Dessert Medley" },
    { id: 32, src: "/resources/images/f&b/f&b32.jpg", category: "Beverage", title: "Cocktail Creation" },
    { id: 33, src: "/resources/images/f&b/f&b33.jpg", category: "Appetizer", title: "Starter Platter" },
    { id: 35, src: "/resources/images/f&b/f&b35.jpg", category: "Dessert", title: "Mini Cakes Selection" },
    { id: 36, src: "/resources/images/f&b/f&b36.jpg", category: "Beverage", title: "Fruit Punch" },
    { id: 37, src: "/resources/images/f&b/f&b37.jpg", category: "Appetizer", title: "Exotic Starter" },
    { id: 38, src: "/resources/images/f&b/f&b38.jpg", category: "Main Course", title: "Gourmet Main" },
    { id: 39, src: "/resources/images/f&b/f&b39.jpg", category: "Dessert", title: "Sweet Bites" },
    { id: 40, src: "/resources/images/f&b/f&b40.jpg", category: "Beverage", title: "Classic Lemonade" },
    { id: 41, src: "/resources/images/f&b/f&b41.jpg", category: "Appetizer", title: "Starter Medley" },
    { id: 42, src: "/resources/images/f&b/f&b42.jpg", category: "Main Course", title: "Chef's Special" },
    { id: 43, src: "/resources/images/f&b/f&b43.jpg", category: "Dessert", title: "Fruit Tart" },
    { id: 44, src: "/resources/images/f&b/f&b44.jpg", category: "Beverage", title: "Mocktail Mix" },
    { id: 45, src: "/resources/images/f&b/f&b45.jpg", category: "Appetizer", title: "Gourmet Platter" },
    { id: 46, src: "/resources/images/f&b/f&b46.jpg", category: "Main Course", title: "Signature Dish" },
    { id: 47, src: "/resources/images/f&b/f&b47.jpg", category: "Dessert", title: "Sweet Assortment" },
    { id: 48, src: "/resources/images/f&b/f&b48.jpg", category: "Beverage", title: "Chilled Mocktail" },
    { id: 49, src: "/resources/images/f&b/f&b49.jpg", category: "Appetizer", title: "Starter Selection" },
    { id: 50, src: "/resources/images/f&b/f&b50.jpg", category: "Main Course", title: "Classic Main" },
    { id: 51, src: "/resources/images/f&b/f&b51.jpg", category: "Dessert", title: "Pastry Medley" },
    { id: 52, src: "/resources/images/f&b/f&b52.jpg", category: "Beverage", title: "Fruit Cooler" },
    { id: 53, src: "/resources/images/f&b/f&b53.jpg", category: "Appetizer", title: "Fusion Platter" },
    { id: 54, src: "/resources/images/f&b/f&b54.jpg", category: "Main Course", title: "Gourmet Plate" },
    { id: 55, src: "/resources/images/f&b/f&b55.jpg", category: "Dessert", title: "Sweet Treats" },
    { id: 57, src: "/resources/images/f&b/f&b57.jpg", category: "Appetizer", title: "Starter Bites" },
    { id: 58, src: "/resources/images/f&b/f&b58.jpg", category: "Main Course", title: "Signature Entrée" },
    { id: 59, src: "/resources/images/f&b/f&b59.jpg", category: "Dessert", title: "Dessert Platter" },
    { id: 60, src: "/resources/images/f&b/f&b60.jpg", category: "Beverage", title: "Iced Tea" },
    { id: 61, src: "/resources/images/f&b/f&b61.jpg", category: "Appetizer", title: "Gourmet Starter" },
    { id: 62, src: "/resources/images/f&b/f&b62.jpg", category: "Main Course", title: "Classic Plate" },
    { id: 63, src: "/resources/images/f&b/f&b63.jpg", category: "Dessert", title: "Sweet Medley" },
    { id: 64, src: "/resources/images/f&b/f&b64.jpg", category: "Beverage", title: "Fruit Punch" },
    { id: 73, src: "/resources/images/f&b/f&b73.jpg", category: "Appetizer", title: "Starter Platter" },
    { id: 74, src: "/resources/images/f&b/f&b74.jpg", category: "Main Course", title: "Signature Main" },
    { id: 77, src: "/resources/images/f&b/f&b77.jpg", category: "Dessert", title: "Mini Pastries" },
    { id: 78, src: "/resources/images/f&b/f&b78.jpg", category: "Beverage", title: "Chilled Drink" },
    { id: 80, src: "/resources/images/f&b/f&b80.jpg", category: "Specialty", title: "Chef's Signature Creation" }
  ];

  return (
    <div className="portfolio-detail-page">
      <Navbar />
      
      {/* Hero Section */}
      <section className="portfolio-detail-hero">
        <h1 className="detail-hero-title">Food & Beverage Photography</h1>
        <div className="title-line"></div>
        <p className="detail-hero-subtitle">Capturing Culinary Artistry in Every Frame</p>
      </section>

      {/* Introduction */}
      <section className="portfolio-intro">
        <div className="intro-content">
          <h2>Culinary Excellence</h2>
          <p>At Stories by Kalakaar, we specialize in capturing the artistry of food and beverages. Our photography brings out the textures, colors, and essence of culinary creations, making every dish and drink look as irresistible as it tastes. From gourmet cuisine to artisanal beverages, we document the passion and creativity behind every creation.</p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="portfolio-gallery">
        <div className="gallery-grid">
          {galleryImages.map((image) => (
            <div key={image.id} className="gallery-item">
              <div className="image-wrapper">
                <img src={image.src} alt={image.title} />
                <div className="image-overlay">
                  <div className="image-info">
                    <span className="image-category">{image.category}</span>
                    <h3 className="image-title">{image.title}</h3>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Services Section */}
      <section className="portfolio-services">
        <div className="services-content">
          <h2>Our Services</h2>
          <div className="services-grid">
            <div className="service-item">
              <h3>Menu Photography</h3>
              <p>Professional food photography for restaurants and menus</p>
            </div>
            <div className="service-item">
              <h3>Beverage Shoots</h3>
              <p>Capturing the artistry of cocktails and drinks</p>
            </div>
            <div className="service-item">
              <h3>Culinary Events</h3>
              <p>Documentation of food festivals and culinary events</p>
            </div>
            <div className="service-item">
              <h3>Product Photography</h3>
              <p>Professional shots for food and beverage products</p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="portfolio-cta">
        <div className="cta-content">
          <h2>Ready to Showcase Your Culinary Art?</h2>
          <p>Let's capture the essence of your food and beverages</p>
          <a href="/contactUs" className="cta-button">Get in Touch</a>
        </div>
      </section>

      <Footer />
    </div>
  );
}; 